import React from 'react';
import './About.css';

export function About() {
  return (
    <section className="about-section">
      <div className="container">
        <h2 className="section-title">Neha Packers & Movers</h2>
        <p className="about-description">
          At Neha Packers & Movers, Local & Domestic, Office: Gaya, Patna, Ranchi, Delhi, we understand that moving is more than just transporting goods; it’s about delivering peace of mind. With over a decade of experience, our dedicated team ensures your belongings are handled with the utmost care. Whether you’re relocating your home or business, we are committed to providing fast, reliable, and eco-friendly services tailored to your needs.
        </p>

        <h2 className="section-title">OUR GOODNESS</h2>
        <h3 className="subtitle">What Makes Us Special</h3>

        <div className="goodness-grid">
          <div className="goodness-item">
            <i className="fas fa-boxes icon"></i>
            <h4>Packaging and Storage</h4>
            <p>We ensure secure packaging and organized storage for all your belongings.</p>
          </div>
          <div className="goodness-item">
            <i className="fas fa-shield-alt icon"></i>
            <h4>Safety & Quality</h4>
            <p>Our priority is the safety and quality of your items during the move.</p>
          </div>
          <div className="goodness-item">
            <i className="fas fa-leaf icon"></i>
            <h4>Care for Environment</h4>
            <p>We use eco-friendly materials and processes to protect the environment.</p>
          </div>
        </div>

        <h2 className="section-title">Why Choose Neha Packers & Movers</h2>

        <div className="choose-grid">
          <div className="choose-item">
            <i className="fas fa-users icon"></i>
            <h4>Dedicated Team</h4>
            <p>Our team is committed to providing exceptional service.</p>
          </div>
          <div className="choose-item">
            <i className="fas fa-bolt icon"></i>
            <h4>Fast and Critical Response</h4>
            <p>Quick responses to your queries and needs.</p>
          </div>
          <div className="choose-item">
            <i className="fas fa-briefcase icon"></i>
            <h4>EST. Feb 2025</h4>
            <p>Decades of expertise in the movers and packers industry.</p>
          </div>
          <div className="choose-item">
            <i className="fas fa-check-circle icon"></i>
            <h4>Committed to Quality</h4>
            <p>We maintain the highest standards of quality in our services.</p>
          </div>
          <div className="choose-item">
            <i className="fas fa-handshake icon"></i>
            <h4>100% Customer Satisfaction</h4>
            <p>We strive to exceed customer expectations every time.</p>
          </div>
        </div>
      </div>
    </section>
  );
};